export default function MainMiddleware() {
  document.body.classList.remove("body-loading");
}
